// extracted by mini-css-extract-plugin
export default {"container":"TableHighlight_container__U8atQ","match":"TableHighlight_match__YXjxh"};